import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromRaffle from '../raffle/raffle.reducer'
import { RaffleEffects } from './raffle.effects'
import { RaffleSerializer } from './raffle.serializer'
import { RaffleService } from './raffle.service'
import { RaffleLotModule } from './raffle-lot/raffle-lot.module'

@NgModule({
    imports: [
        SharedModule,
        StoreModule.forFeature(fromRaffle.FEATURE_NAME, fromRaffle.raffleReducer),
        EffectsModule.forFeature([RaffleEffects]),
        RaffleLotModule
    ],
    declarations: [],
    exports: [],
    providers: [
        RaffleService,
        {
            provide: RaffleSerializer,
            useClass: RaffleSerializer
        }
    ]
})
export class RaffleModule {}
